import { render, staticRenderFns } from "./_ChannelForm.vue?vue&type=template&id=8baf0514&scoped=true&"
import script from "./_ChannelForm.vue?vue&type=script&lang=ts&"
export * from "./_ChannelForm.vue?vue&type=script&lang=ts&"
import style0 from "./_ChannelForm.vue?vue&type=style&index=0&id=8baf0514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baf0514",
  null
  
)

export default component.exports